import React          from 'react'
import ReactDOM       from 'react-dom'
import BaseController from 'controllers/base'
import                     'scrollpos-styler/scrollPosStyler.js'
import KeyFactsCalculator from '../../containers/Calculators/KeyFactsCalculator';

class Controller extends BaseController {
  call() {
    super.call();
    bindNavbarCollapsable.call(this);

    if (document.getElementById("react-root")) {
      ReactDOM.render(<KeyFactsCalculator />, document.getElementById("react-root"))
    }
  }
};

// This adds/remove the class `navbar-collapsable-show` on the main nav
let bindNavbarCollapsable = function() {
  $('#navbarSupportedContent').on('show.bs.collapse', function () {
    $('.navbar-pages').addClass('navbar-collapsable-show')
  })

  $('#navbarSupportedContent').on('hidden.bs.collapse', function () {
    $('.navbar-pages').removeClass('navbar-collapsable-show')
  })
}

export default Controller;
